import { FormFieldConfig } from "Components/Common/CommonForm";
import { Column } from "Components/Common/CommonTableIndexWise";
import styles from "../css/blockVolunteerList.module.scss";
import { formatDate, parseLocalDate } from "common/service/CommonService";
import { Link } from "react-router-dom";
import { BLOCK_VOLUNTEER_PATHS } from "Routes/paths";
import { validations } from "validations/FormValidations";

export const blockVolunteerColumns: Column[] = [
  {
    key: "subjectno",
    label: "Study Code / Subject No",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <Link
            to={BLOCK_VOLUNTEER_PATHS.VIEW.replace(":id", (row.blockid || row.id).toString())}
            className="mb-0 fw-medium text-primary text-decoration-none d-block"
          >
            {row.studycode || "—"}
          </Link>
          <p className="mb-0 text-muted fs-12">
            {row.subjectno || "—"}
          </p>
        </>
      );
    },
  },
  {
    key: "initials",
    label: "Subject Initial",
  },
  {
    key: "blocktype",
    label: "Block Type",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <span className={row.blocktype === "Temporary" ? styles.badgeTemp : styles.badgePerm}>
          {row.blocktype}
        </span>
      );
    },
  },
  {
    key: "remarks",
    label: "Remarks/Reason",
    tooltip: true,
    maxLength: 30
  },
  {
    key: "startdate",
    label: "Start Date",
    render: (value: any) => (value ? formatDate(value) : "—"),
  },
  {
    key: "enddate",
    label: "End Date",
    render: (value: any) => (value ? formatDate(value) : "—"),
  },
  {
    key: "blockstatus",
    label: "Block Status",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <span className={styles.badgeStatus}>
          {row.blockstatus}
        </span>
      );
    },
  },
  {
    key: "verifiedby",
    label: "Verified By",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <p className="mb-0 fw-medium text-dark">{row.verifiedbytext || "—"}</p>
          <p className="mb-0 text-muted fs-12">
            {row.verifieddate ? formatDate(row.verifieddate) : "—"}
          </p>
        </>
      );
    },
  },
];

// ─────────────────────────────────────────────
// Fields configurations generator
// ─────────────────────────────────────────────

export const getSubjectFields = (): FormFieldConfig[] => [
  {
    name: "studycode",
    label: "Study Code",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    name: "subjectno",
    label: "Subject Number",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    name: "subjectinitial",
    label: "Subject Initial",
    placeholder: "Enter Subject Initials",
    type: "text",
    required: true,
    disabled: true,
  },
];

export const getBlockTypeFields = (blockType: string | null, isEditMode: boolean = false): FormFieldConfig[] => [
  {
    name: "blocktype",
    label: "Block Type",
    type: "radio",
    required: true,
    disabled: isEditMode,
    options: [
      { label: "Temporary", value: "Temporary" },
      { label: "Permanent", value: "Permanent" },
    ],
    description:
      blockType === "Temporary"
        ? "Temporary blocks require a defined end date. "
        : "Permanent blocks are lifetime exclusions and cannot be reversed automatically.",
  },
];

export const getDateFields = (blockType: string | null, startDate: string | null = null): FormFieldConfig[] => {
  const fields: FormFieldConfig[] = [
    {
      name: "startdate",
      label: "Block Start Date",
      type: "date",
      required: true,
    },
  ];

  if (blockType === "Temporary") {
    fields.push({
      name: "enddate",
      label: "Block End Date",
      type: "date",
      required: true,
      disabled: !startDate,
      optionsProps: {
        minDate: startDate ? (parseLocalDate(startDate) || undefined) : undefined,
      },
    });
    fields.push({
      name: "blockduration",
      label: "Block Duration",
      type: "text",
      disabled: true,
    });
  }

  return fields;
};

export const reasonFields = (BLOCK_REASONS_OPTIONS: any): FormFieldConfig[] => [
  {
    name: "blockreason",
    label: "Block Reason",
    type: "select",
    required: true,
    options: BLOCK_REASONS_OPTIONS,
  },
  {
    name: "remarks",
    label: "Detailed Remarks",
    type: "textarea",
    placeholder: "Enter detailed blocking notes...",
    rules: validations.blockvolunteer.detailedremarks
  },
];

export const eligibilityFields: FormFieldConfig[] = [
  {
    name: "rescreeningeligibility",
    label: "Re-screening Eligibility",
    type: "radio",
    options: [
      { label: "Eligible after block period", value: "Eligible after block period" },
      { label: "Requires PI review", value: "Requires PI review" },
    ],
  },
];
